export { default as TableSolidIcon } from './TableSolidIcon';
